import {
    GET_ADMINS_REQUESTED,
    GET_ADMINS_SUCCESS,
    GET_ADMINS_FAILED,
    ADD_ADMIN_REQUESTED,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAILED,
    UPDATE_ADMIN_REQUESTED,
    UPDATE_ADMIN_SUCCESS,
    UPDATE_ADMIN_FAILED,
    DELETE_ADMIN_REQUESTED,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAILED,
} from '../actions/types';

const initialState = {
    admins: [],
    admin: null,
    adminsGetRequested: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ADMINS_REQUESTED:
            return {
                ...state,
                adminsGetRequested: true,
            };
        case GET_ADMINS_SUCCESS:
            return {
                ...state,
                admins: action.payload,
                adminsGetRequested: false,
            };
        case GET_ADMINS_FAILED:
            return {
                ...state,
                adminsGetRequested: false,
            };
        case ADD_ADMIN_SUCCESS:
            return {
                ...state,
                admins: [...state.admins, action.payload],
            };
        case UPDATE_ADMIN_SUCCESS:
            return {
                ...state,
                admins: state.admins.map((admin) =>
                    admin.id === action.payload.id ? action.payload : admin
                ),
            };
        case DELETE_ADMIN_SUCCESS:
            return {
                ...state,
                admins: state.admins.filter((admin) => admin.id !== action.payload.id),
            };
        default:
            return state;
    }
}
